import { render, staticRenderFns } from "./Runtime.vue?vue&type=template&id=3021f22e&scoped=true&"
import script from "./Runtime.vue?vue&type=script&lang=js&"
export * from "./Runtime.vue?vue&type=script&lang=js&"
import style0 from "./Runtime.vue?vue&type=style&index=0&id=3021f22e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3021f22e",
  null
  
)

export default component.exports